import { Outlet } from 'react-router-dom';
import Footer from '../Footer';
import AdminHeader from '../Header/AdminHeader';

// Access control lives in <RequireAuth adminOnly> around this layout (see App.js).
export default function AdminLayout() {
  return (
    <>
      <AdminHeader logoSrc="/noohra.png" variant="cs_heading_color" />
      {/* Small gap below the fixed header on phones; desktop spacing is unchanged. */}
      <div className="pt-6 md:pt-0">
        <Outlet />
      </div>
      <Footer />
    </>
  );
}
